import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  subscriptionDashboard: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    width: '100%',
    gap: '16px',
  },
  datesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: '16px',
    flexWrap: 'wrap',
  },
  dateItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  dateLabel: {
    color: theme.evPalette.charcoal[700],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  dateValue: {
    color: theme.evPalette.charcoal[900],
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  usageContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    backgroundColor: theme.evPalette.charcoal[100],
    borderRadius: '4px',
    gap: '16px',
  },
  usageTitle: {
    color: theme.evPalette.charcoal[700],
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
  usageStatsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    gap: '16px',
  },
  usageProgressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
  progressSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  progressContainer: {
    position: 'relative',
    width: '140px',
    height: '70px',
    overflow: 'hidden',
  },
  progressBar: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '140px',
    height: '140px',
    borderRadius: '70px 70px 0 0',
    transformOrigin: 'center bottom',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '20px',
      left: '20px',
      width: '100px',
      height: '100px',
      borderRadius: '50px 50px 0 0',
      backgroundColor: theme.evPalette.charcoal[100],
    },
  },
  progressValueContainer: {
    position: 'relative',
    top: '-25px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
    zIndex: 20,
  },
  usageNumberContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  usageNumber: {
    color: theme.evPalette.charcoal[900],
    fontSize: '48px',
    fontWeight: 700,
    lineHeight: '56px',
    fontFamily: 'Noto Sans',
  },
  usageTotal: {
    color: theme.evPalette.charcoal[700],
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px',
    fontFamily: 'Noto Sans',
  },
  usageDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'flex-start',
  },
  usageDetailsItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: '4px',
  },
  usageDetail: {
    color: theme.evPalette.charcoal[700],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  progressBarContainer: {
    display: 'none',
  },
  warningAlert: {
    borderRadius: '4px',
    backgroundColor: theme.evPalette.rose[100],
    border: `1px solid ${theme.evPalette.rose[300]}`,
    '& .MuiAlert-message': {
      color: theme.evPalette.charcoal[900],
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
    },
    '& .MuiAlert-icon': {
      color: theme.evPalette.rose[700],
    },
  },
  warningContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  warningIcon: {
    color: theme.evPalette.ocean[600],
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'stretch',
  },
  pricingItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '8px',
    flex: 1,
  },
  pricingDivider: {
    width: '1px',
    backgroundColor: theme.evPalette.charcoal[400],
    margin: '0 24px',
    alignSelf: 'stretch',
  },
  pricingLabel: {
    color: theme.evPalette.charcoal[700],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  pricingValue: {
    color: theme.evPalette.charcoal[900],
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px',
  },
  overageBadge: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: theme.evPalette.mango[700],
    borderRadius: '8px',
    padding: '2px 8px',
    position: 'relative',
    top: '-10px',
  },
}));
